import { FC, PropsWithChildren } from 'react';

import { FinancialOverviewSectionDragControl } from '../../types';
import { FinancialOverviewSectionDragContext } from './context';

export const FinancialOverviewSectionDragProvider: FC<
    PropsWithChildren<{ value: FinancialOverviewSectionDragControl }>
> = ({ children, value }) => (
    <FinancialOverviewSectionDragContext.Provider value={value}>
        {children}
    </FinancialOverviewSectionDragContext.Provider>
);
